var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn-group" }, [
    _vm.canEdit
      ? _c(
          "button",
          { staticClass: "btn btn-secondary btn-sm", on: { click: _vm.edit } },
          [_c("i", { staticClass: "fas fa-edit" })]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.canDelete
      ? _c(
          "button",
          {
            staticClass: "btn btn-danger btn-sm",
            on: { click: _vm.confirmDeleting },
          },
          [_c("i", { staticClass: "fas fa-trash-alt" })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }